import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHomeworkSubmission } from "../../hooks/homework";
import HomeworkFeedback from "../../views/Content/Courses/Homework/HomeworkFeedback";

const AdminHomeworkSubmission = ({ homeworkSubmissionId }) => {
  const [homeworkSubmission, setHomeworkSubmission] = useState({});
  const { getHomeworkSubmission } = useHomeworkSubmission();
  useEffect(() => {
    getHomeworkSubmission(homeworkSubmissionId).then(submissionData =>
      setHomeworkSubmission(submissionData)
    );
  }, []);

  return (
    <HomeworkFeedback
      submissionData={homeworkSubmission}
      onClose={() => window.close()}
    />
  );
};

AdminHomeworkSubmission.propTypes = {
  homeworkSubmissionId: PropTypes.string
};

export default AdminHomeworkSubmission;
